<ng-container *ngIf="is_ready">
  <mat-toolbar fxLayout="row" class="wrapper-header" color="primary" [ngStyle]="headerStyle" *ngIf="header">
    <div fxFlex>
      <span class="title">{{ header }}</span><span class="item-count">({{ busyAgents.length }})</span>
    </div>
    <div fxFlex="40px">
      <button type="button" mat-icon-button (click)="displayContent = !displayContent">
        <mat-icon *ngIf="!displayContent">expand_more</mat-icon>
        <mat-icon *ngIf="displayContent">expand_less</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-card class="mat-card-flat pa-0 mt-0 mx-0 mb-1 wrapper-content" fxLayout="column">
    <div fxLayout="column" fxLayoutGap="10px" [hidden]="!displayContent" *ngIf="has_busy_agent">
      <ng-container *ngFor="let agent of busyAgents; let i = index">
        <ng-container
          *ngTemplateOutlet="agent.reserved ? tplActiveCall: tplPauseAgent; context: {agent: agent, queueItem: getQueueItemByAgent(agent), idx: i}">
        </ng-container>
      </ng-container>
    </div>
  </mat-card>

  <ng-template #tplPauseAgent let-agent="agent">
    <div fxLayout="column" class="bg-gray agent-wrapper">
      <div>
        <agent-item [avatar]="true" [agent]="agent" [actions]="agentActions" actionDisplayType="toolbar">
        </agent-item>
      </div>
      <div *ngIf="displayGroup" class="group-list-wrapper">
        <agent-groups [agent]="agent"></agent-groups>
      </div>
    </div>
  </ng-template>

  <ng-template #tplActiveCall let-queueItem="queueItem" let-agent="agent" let-i="idx">
    <div fxLayout="row" class="active-call-container">
      <!-- content -->
      <div fxFlex="auto" fxLayout="row" fxLayout.xs="column">
        <div fxFlex="auto" fxLayout="column">
          <div fxFlex="auto" fxLayout="row" fxLayout.xs="column">
            <!-- avatar -->
            <div fxFlex="70px" fxLayout="column" fxLayoutAlign="center center" class="bg-gray call-avatar"
              ngClass.gt-xs="py-0-5 pa-1">
              <user-avatar [user]="agent?.user" width="50px" height="50px"
                [matTooltip]="agent?.name">
              </user-avatar>
            </div>

            <!-- call number, group, queue -->
            <div fxFlex=" auto" fxLayout="column" fxLayoutAlign="center start" class="bg-gray call-number"
              ngClass.xs="p-5px" ngClass.gt-xs="pa-1 pa-0-5">
              <div class="agent-name font-weight-bold font-lg">{{ agent?.name }} </div>

              <ng-template #tplNoQueueItem>
                <div fxLayout="row" fxLayoutAlign="start center" class="phone-number font-weight-bold text-lg"
                fxLayoutGap="3px">
                <!-- call direction -->
                <span fxLayout="column" fxLayoutAlign="center center" class="py-0" [ngClass]="{
                  'bg-ring': agent && agent.reserved,
                  'call-direction': true
                }">
                  <mat-icon *ngIf="agent && agent.agent_status_detail == 'call_out'">arrow_upward</mat-icon>
                  <mat-icon *ngIf="agent && agent.agent_status_detail == 'call_in'">arrow_downward</mat-icon>
                  <mat-icon *ngIf="agent && agent.agent_status_detail == 'internal_call'">sip</mat-icon>
                </span>
              </div>
              </ng-template>
              
              <div fxLayout="row" fxLayoutAlign="start center" class="phone-number font-weight-bold text-lg"
                fxLayoutGap="3px" *ngIf="queueItem; else tplNoQueueItem">
                <!-- call direction -->
                <span fxLayout="column" fxLayoutAlign="center center" class="py-0" [ngClass]="{
                  'bg-onhold': isSessionOnhold(queueItem), 
                  'bg-ring': queueItem && !queueItem.is_handled || !isSessionBridged(queueItem),
                  'bg-handled': isSessionBridged(queueItem),
                  'call-direction': true
                }">
                  <ng-container *ngIf="queueItem && queueItem.is_outgoing; else inCall">
                    <mat-icon>arrow_upward</mat-icon>
                  </ng-container>
                  <ng-template #inCall>
                    <mat-icon>arrow_downward</mat-icon>
                  </ng-template>
                </span>
                <span class="font-18" *ngIf="queueItem">{{ normalizeNumber(queueItem.remote_number) }}</span>
              </div>
              <!-- group, queue -->
              <div fxLayout="row" fxLayoutAlign="start center" class="call-info" fxLayoutGap="3px" *ngIf="queueItem">
                <mat-icon class="icon-group">group</mat-icon>
                <span class="queue-name">{{ queueItem.queue?.queue_name }}</span>
                <span *ngIf="queueItem.group_id && hasFeature(FeatureName.SERVICE_GROUP)" class="group-name pl-1">
                  ({{ queueItem.group?.name }})</span>
              </div>
            </div>

          </div>

          <div *ngIf="displayGroup" class="group-list-wrapper bg-gray">
            <agent-groups [agent]="agent"></agent-groups>
          </div>

        </div>

        <ng-template #tplNoQueueItemCallStatus>
          <div fxFlex="300px" fxFlex.xs="initial" fxFlex.sm="initial" fxLayout="column" fxLayoutAlign="center center"
            class ="bg-gray" [ngClass]="{
            'bg-ring': agent && agent.reserved,
            'call-status': true,
            'pa-0-5': true
            }" [ngClass.sm]="{
            'bg-ring': agent && agent.reserved,
            'call-status': true,
            'pa-7': true
          }" *ngIf="agent && agent.reserved">
            <div>
              <ng-container *ngIf="agent.agent_status_detail == 'call_out'">
                {{ 'livecall.call_outgoing'|translate }}
              </ng-container>
              <ng-container *ngIf="agent.agent_status_detail == 'call_in'">
                {{ 'livecall.call_incoming'|translate }}
              </ng-container>
              <ng-container *ngIf="agent.agent_status_detail == 'internal_call'">
                {{ 'livecall.call_internal'|translate }}
              </ng-container>
            </div>
          </div>
        </ng-template>
        

        <!-- call status -->
        <div fxFlex="300px" fxFlex.xs="initial" fxFlex.sm="initial" fxLayout="column" fxLayoutAlign="center center"
          class="bg-gray" [ngClass]="{
          'bg-onhold': queueItem && isSessionOnhold(queueItem), 
          'bg-ring': queueItem && (!queueItem.is_handled || !isSessionBridged(queueItem)),
          'bg-handled': isSessionBridged(queueItem),
          'call-status': true,
          'pa-0-5': true
          }" [ngClass.sm]="{
          'bg-onhold': isSessionOnhold(queueItem), 
          'bg-ring': queueItem && (!queueItem.is_handled || !isSessionBridged(queueItem)),
          'bg-handled': isSessionBridged(queueItem),
          'call-status': true,
          'pa-7': true
        }" *ngIf="queueItem; else tplNoQueueItemCallStatus">
          <div *ngIf="isSessionBridged(queueItem); else notSessionBridged">
            <ng-container *ngIf="queueItem?.is_outgoing; else inCall">
              {{ 'livecall.call_outgoing'|translate }}
            </ng-container>
            <ng-template #inCall>
              {{ 'livecall.call_incoming'|translate }}
            </ng-template>
          </div>
          <ng-template #notSessionBridged>
            <div fxLayout="row wrap" fxLayoutAlign="start center">
              <mat-chip-list fxFlex="100" *ngIf="queueItem?.forced_operator_id">
                <mat-chip color="warn" selected class="pt-0 pb-0">
                  ( {{ getAgentById(queueItem.forced_operator_id)?.name }}*)
                </mat-chip>
              </mat-chip-list>
              <div fxFlex="auto">{{ 'livecall.call_waiting'|translate }}</div>
              <mat-chip-list fxFlex="auto">
                <mat-chip color="warn" selected class="pt-0 pb-0">
                  ( {{ (queueItem?.is_outgoing ? 'livecall.call_outgoing' : 'livecall.call_incoming')|translate }} )
                </mat-chip>
              </mat-chip-list>
            </div>
          </ng-template>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
            <div fxFlex="auto">
              <mat-icon class="icon-time">access_time</mat-icon>&nbsp;
              <timer-since *ngIf="isSessionBridged(queueItem)" [since]="queueItem.session.bridged_dt"
                class="timer-since font-weight-bold"></timer-since>
              <timer-since *ngIf="!(isSessionBridged(queueItem) || !queueItem.arrive_dt)" [since]="queueItem.arrive_dt"
                class="timer-since font-weight-bold">
              </timer-since>
            </div>
            <div fxFlex="auto" matTooltip="{{ 'livecall.call_onhold'|translate }}" *ngIf="queueItem.session?.is_onhold">
              <mat-icon class="icon-hourglass">hourglass_empty</mat-icon>&nbsp;
              <timer-since [since]="queueItem.session.last_onhold_dt" class="timer-since font-weight-bold">
              </timer-since>
            </div>
          </div>
        </div>

      </div>

      <!-- actions -->
      <div fxLayoutAlign="center end" class="menu-container" *ngIf="queueItem">
        <div class="menu-toolbar-wrapper">
          <button mat-icon-button [matMenuTriggerFor]="actionMenu" *ngIf="isVisibleBusyAgentEavesdrop(queueItem)">
            <mat-icon>headset</mat-icon>
          </button>

          <button mat-icon-button color="warn" *ngIf="isVisibleBusyAgentRemoveEavesdrop(queueItem)"
            (click)="handleClickRemoveEavesdropAgent(queueItem)">
            <mat-icon>headset_off</mat-icon>
          </button>

          <mat-menu #actionMenu>
            <button mat-menu-item (click)="handleClickEavesdropCall(queueItem)">
              <mat-icon class="text-success">call</mat-icon>
              <span>{{'live_tracking.actions.eavesdrop_call'|translate}}</span>
            </button>
            <button mat-menu-item (click)="handleClickEavesdropAgent(queueItem)">
              <mat-icon class="text-success">support_agent</mat-icon>
              <span>{{'live_tracking.actions.eavesdrop_agent'|translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>

    </div>
  </ng-template>

</ng-container>
